<template>
    <div class="ChatControls">
        <div class="ChatControls__in">
            <div id="fileInput" class="fileInput" ref="fileInput">
                <div class="fileInput__trigger">
                    <svg width="27" height="30" viewBox="0 0 27 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M22.5931 15.5727L12.4519 25.7139C9.86846 28.3111 6.4056 28.05 4.19321 25.8238C1.95334 23.5977 1.70599 20.1486 4.30314 17.5514L18.1683 3.68622C19.6799 2.17466 21.9473 1.89982 23.4176 3.38391C24.9017 4.868 24.6269 7.10787 23.1153 8.63318L9.51118 22.251C8.89281 22.8694 8.16451 22.6908 7.73852 22.2785C7.32628 21.8388 7.14764 21.1242 7.76601 20.4921L17.2477 11.0105C17.7286 10.5295 17.7561 9.82869 17.3026 9.36148C16.8354 8.92175 16.1346 8.93549 15.6536 9.41644L6.11702 18.9393C4.66042 20.4234 4.71539 22.677 6.02083 23.9825C7.43621 25.3979 9.57989 25.3704 11.064 23.8863L24.7368 10.2135C27.3889 7.56134 27.2927 4.07099 24.9704 1.73493C22.6893 -0.532427 19.144 -0.697325 16.4781 1.95479L2.53048 15.9299C-0.946126 19.4065 -0.71252 24.3947 2.44803 27.5553C5.60859 30.7021 10.6105 30.9494 14.0871 27.4866L24.2971 17.2766C24.7643 16.8231 24.7505 15.9849 24.2833 15.5314C23.8299 15.0505 23.0741 15.1192 22.5931 15.5727Z"
                            fill="#D8DCDE"/>
                    </svg>
                </div>
                <div class="fileInput__component">
                    <AInput  v-model="fileInput" @change="send" type="file"/>
                </div>
            </div>
            <div class="emoji" ref="emoji">
                <EmojiSelector @input="onEmojiSelect"/>
            </div>
          <div class="chatInput">
                <AInput :autogrow="true" v-model="textInput" type="text" @keyup="testKey" :placeholder="messages.messageInputPlaceholder"/>

                <div class="chatInput__trigger" @click="send">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M8.02344 16.1445V20.396C8.02344 20.693 8.2141 20.9561 8.49644 21.0496C8.56702 21.0725 8.63944 21.0835 8.71093 21.0835C8.92543 21.0835 9.1326 20.9827 9.2646 20.803L11.7515 17.4187L8.02344 16.1445Z"
                            fill="#6367A7"/>
                        <path
                            d="M21.7113 0.127498C21.5005 -0.0219188 21.2236 -0.0420854 20.9945 0.0779979L0.369457 10.8488C0.125624 10.9762 -0.0182926 11.2366 0.0018741 11.5107C0.0229574 11.7857 0.205374 12.0203 0.464791 12.1092L6.19854 14.0691L18.4095 3.62825L8.96046 15.0123L18.5699 18.2967C18.6414 18.3206 18.7165 18.3334 18.7917 18.3334C18.9164 18.3334 19.0401 18.2995 19.1492 18.2335C19.3234 18.1272 19.4416 17.9484 19.4719 17.7477L21.9927 0.789331C22.0303 0.532665 21.9221 0.277831 21.7113 0.127498Z"
                            fill="#6367A7"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, onMounted, nextTick} from "vue";
import {AInput} from "../ui";
import EmojiSelector from "./EmojiSelector";

export default {
    name: "ChatControls",
    props: {
      messages: {
        type: Object
      }
    },
    components: {
        EmojiSelector,
        AInput
    },
    emits:['send'],
    setup(props, ctx) {
        const fileInput = ref(null);
        const textInput = ref('');
        const emoji = ref(null);

        const testKey = (e)=>{
          if(e.keyCode===13) {
            nextTick(()=>{
              send();
            });
          }
        };
        const send = () => {
          let file = false;
          if(fileInput.value.length) {
            file = fileInput.value[0];
          }
          ctx.emit('send',{
            file:file,
            text:textInput.value
          });
          nextTick(()=>{
            fileInput.value=null;
            textInput.value=null;
          });
        };

        onMounted(() => {
            //emoji.value.querySelector('.v3-input-picker-icon img').src = '/local/templates/main/img/icons/face.smiling.svg'

            const fileTrigger = document.querySelector('.fileInput__trigger')
            fileTrigger.addEventListener('click', () => {
                fileInput.value.querySelector('.input').click()
            })
        })


        const onEmojiSelect = (event) => {
          textInput.value+=event.i;
            console.log('onEmojiSelect,', event)
        }

        return {
            onEmojiSelect,
            fileInput,
          testKey,
          textInput,
            send,
            emoji
        }
    }
}
</script>

<style scoped lang="scss">
.ChatControls {
    position: relative;
    margin-top: auto;

    @include mobile {
        margin-bottom: 15px;
    }

    ::v-deep .field {
        margin: 0;
    }

    &__in {
        display: flex;
        align-items: center;
    }

    margin-bottom: 40px;
}

.fileInput {
    &__component {
        visibility: hidden;
        position: absolute;
        left: 0;
        top: 0;
        width: 1px;
        height: 1px;
    }

    &__trigger {
        cursor: pointer;
    }
}

.chatInput {
    width: 100%;
  margin-left: 10px;
    position: relative;
    display: flex;
    align-items: center;

    &__trigger {
        position: absolute;
        right: 15px;
        z-index: 100;
    }

    ::v-deep .label {
        display: none;
    }

    ::v-deep .field{
        width: 100%;
    }

    ::v-deep .input {
        padding-right: 55px;
    }
}
</style>